import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"; // <-- Added useSelector
import { useParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material"; // <-- Added MUI components

import { updateDraftRequest } from "../../redux/drafts/draftsSlice";
import SolutionFormDialog from "../CreateSolutionField/SolutionFormDialog";
import { createEmptySolutionForm } from "../CreateSolutionField/solutionFormDefaults";
import { updatePublishedSolutionRequest } from "../../redux/published/publishedSolutionsSlice";

const EditDraftDialog = ({
  open,
  draft,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [solutionForm, setSolutionForm] = useState(
    createEmptySolutionForm()
  );

  // ==========================================
  // NEW: State to track saving status
  // ==========================================
  const [isSaving, setIsSaving] = useState(false);

  const draftItems = useSelector((state) => state.drafts?.items);
  const publishedItems = useSelector((state) => state.publishedSolutions?.items);

  // Watch for data updates: when Cassandra finishes and Redux updates, close the modal!
  useEffect(() => {
    if (isSaving) {
      setIsSaving(false);
      onClose();
    }
  }, [draftItems, publishedItems]); // Triggers when the backend returns fresh data
  // ==========================================

  useEffect(() => {
    if (draft) {
      const sourceData = draft.rawData || draft.combinedData || {};

      setSolutionForm({
        ...createEmptySolutionForm(),
        ...sourceData,
        id: draft.entryId,
      });
    }
  }, [draft]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setSolutionForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    // 1. Turn on the spinner!
    setIsSaving(true);
    
    // Fallback to entryId just in case
    const targetId = draft.id || draft.entryId; 

    // If it is a published solution, send to the published saga
    if (draft.isPublished) {
      dispatch(
        updatePublishedSolutionRequest({
          id: targetId,
          data: solutionForm,
          projectId: projectId,
        })
      );
    } else {
      // Otherwise, update the draft
      dispatch(
        updateDraftRequest({
          id: targetId,
          data: solutionForm,
          projectId: projectId,
        })
      );
    }

    // 2. We removed the instant onClose() here! 
    // The useEffect above will handle closing it smoothly once the data saves.
  };

  if (!draft) return null;

  return (
    <SolutionFormDialog
      open={open}
      onClose={onClose}
      form={solutionForm}
      onChange={handleChange}
      onSave={handleSave}
      title="Edit Draft"
      // 3. Swap the simple text string for a dynamic layout
      saveLabel={
        isSaving ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} color="inherit" />
                <span>Saving...</span>
            </Box>
        ) : (
            "Save Changes"
        )
      }
    />
  );
};

export default EditDraftDialog;